import * as React from 'react'

import { SpeedloSpinner as UISpeedloSpinner } from '~ui/components/Loading/Spinner/SpeedloSpinner'

type TSpinnerProps = Pick<PropsOf<typeof UISpeedloSpinner>, `size` | `thickness` | `minHeight`>

type TProps = NoChildren & TSpinnerProps

/**
 * Loading spinner with ee logo in the middle, with company primary spinning line.
 */
export const SpeedloSpinner: React.FC<TProps> = ({ size = `lg`, thickness = `sm`, minHeight }) => {
  return (
    <UISpeedloSpinner
      size={size}
      eeOpacity={0.1}
      thickness={thickness}
      minHeight={minHeight}
      color={`specialColors.company`}
    />
  )
}
